module.exports = __webpack_public_path__ + "static/IBMPlexSans-Regular-bb07700dc58a6d40a80c0632e0e09c38.woff2";